import * as React from "react";
import TextField from "@mui/material/TextField";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { StaticDatePicker } from "@mui/x-date-pickers/StaticDatePicker";
import dayjs from "dayjs";

const Calendar = ({ value, setValue }) => {
  return (
    <>
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <StaticDatePicker
          displayStaticWrapperAs="desktop"
          openTo="day"
          minDate={dayjs()}
          maxDate={dayjs().add(60, "day")}
          value={value}
          onChange={(newValue) => {
            setValue(newValue);
          }}
          textField={(params) => <TextField {...params} />}
        />
      </LocalizationProvider>
    </>
  );
};

export default Calendar;
